import React from 'react';

export const useQueue = <T>(initialValue: T[] = []) => {
  const [queue, setQueue] = React.useState(initialValue);

  const add = React.useCallback(element => {
    setQueue(q => [...q, element]);
  }, []);

  const remove = () => {
    const [first] = queue;

    setQueue(([_first, ...q]) => {
      return q;
    });

    return first;
  };

  const clear = React.useCallback(() => {
    setQueue([]);
  }, []);

  return {
    add,
    remove,
    clear,
    first: queue[0],
    last: queue[queue.length - 1],
    size: queue.length,
    queue,
  };
};
